export var DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON;
(function (DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON) {
  DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON[DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON["L"] = 4] = "L";
  DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON[DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON["M"] = 3] = "M";
})(DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON || (DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON = {}));
export var DEVICE_NAME_SYMBOL_SIZE = 76;
export var DEVICE_ONE_LINE_NAME_SYMBOL_SIZE = 38;
export var DEVICE_STATIC_TEXTS;
(function (DEVICE_STATIC_TEXTS) {
  DEVICE_STATIC_TEXTS["IN_FAVORITE"] = "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u043C";
  DEVICE_STATIC_TEXTS["OUT_OF_FAVORITE"] = "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435";
})(DEVICE_STATIC_TEXTS || (DEVICE_STATIC_TEXTS = {}));